import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-[60vh] grid place-items-center">
        <span className="serif text-3xl text-[#D4AF37] slow-pulse">✦</span>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
